'use strict';

jQuery($ => {
    let lastPosition = -1;
    const desktopHeader = $('.gecko-header-desktop');
    const pageHeader = $('.gecko-page__header');
    const pageHeaderHeight = pageHeader.outerHeight();

    const fillerHeight = $('.fixed-header-padding').outerHeight();
    let panelHeader = $('.gecko-panel-header');

    let position = "high";

    function mainLoop() {

        if (lastPosition == window.pageYOffset) {
            requestAnimationFrame(mainLoop);
            return false;
        } else {
            lastPosition = window.pageYOffset;
            if (lastPosition >= (pageHeaderHeight - fillerHeight)) {
                if (position == "high") {
                    position = "low";
                    desktopHeader.attr('data-scrolled', 'active');
                    panelHeader.attr('data-scrolled', 'active')
                }
            } else {
                if (position == "low") {
                    position = "high";
                    desktopHeader.removeAttr('data-scrolled');
                    panelHeader.removeAttr('data-scrolled');
                }
            }
        }

        requestAnimationFrame(mainLoop);
    }

    requestAnimationFrame(mainLoop);
});